/**
 * <s-signup-popup> opens its child <dialog> once per visitor, a short delay after
 * first landing. Closing it (or signing up) stores a flag so it never nags again.
 * Attributes: delay (ms, default 2500).
 */
const STORAGE_KEY = 'batsnoni:signup-popup-seen';

class SSignupPopup extends HTMLElement {
  #timer;

  connectedCallback() {
    const dialog = this.querySelector('dialog');
    if (!dialog) return;

    dialog.addEventListener('close', () => this.#remember());
    this.querySelector('form')?.addEventListener('submit', () => this.#remember());

    if (this.#seen()) return;
    const delay = Number(this.getAttribute('delay')) || 2500;
    this.#timer = setTimeout(() => {
      if (!dialog.open && !document.querySelector('dialog[open]')) dialog.showModal();
    }, delay);
  }

  disconnectedCallback() {
    clearTimeout(this.#timer);
  }

  #seen() {
    try { return localStorage.getItem(STORAGE_KEY) === '1'; } catch { return false; }
  }

  #remember() {
    try { localStorage.setItem(STORAGE_KEY, '1'); } catch { /* storage blocked */ }
  }
}

if (!customElements.get('s-signup-popup')) customElements.define('s-signup-popup', SSignupPopup);
